// Base
import { useState, useEffect } from "react";
import parse from "html-react-parser";

// Store
import { useTemplateStore } from "@/zustand/templateStore";

// Helpers
import { setCookie, getCookie } from "@/utils/helpers";

export default function Header() {
  const { colors, topBar, settings } = useTemplateStore();

  const initialSeconds = topBar.top_bar_time * 60;
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);
  const [shouldShowTimer, setShouldShowTimer] = useState(true);

  useEffect(() => {
    let t = getCookie("checkout_timer");
    const now = Date.now();
    if (!t) {
      const endAt = now + initialSeconds * 1000;
      t = { endAt, cooldownExpires: endAt + 24 * 60 * 60 * 1000 };
      setCookie("checkout_timer", t, t.cooldownExpires);
    }
    const timeLeft = Math.max(Math.floor((t.endAt - now) / 1000), 0);
    setSecondsLeft(timeLeft);
    if (timeLeft === 0) setShouldShowTimer(false);
    if (timeLeft === 0) return;

    let prev = timeLeft;
    const start = Date.now();

    const interval = setInterval(() => {
      const elapsed = Math.floor((Date.now() - start) / 1000);
      const next = Math.max(timeLeft - elapsed, 0);
      if (next !== prev) {
        prev = next;
        setSecondsLeft(next);
      }
      if (next === 0) {
        setShouldShowTimer(false);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [initialSeconds]);

  const formatTime = (sec: number) => {
    const minutes = Math.floor(sec / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (sec % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const headerStyle = colors?.top_bar_background
    ? { backgroundColor: colors.top_bar_background }
    : undefined;

  const countdownStyle = colors?.top_bar_time_text
    ? { color: colors.top_bar_time_text }
    : undefined;

  const hasTimer = topBar.tr_top_bar_label.includes("xx:xx");
  const [before, after] = topBar.tr_top_bar_label.split("xx:xx");

  if (!topBar?.show_top_bar) return null;
  if (hasTimer && (!shouldShowTimer || secondsLeft <= 0)) return null;

  return (
    <header
      className={`px-2 pt-2 pb-2 ${!colors?.top_bar_background ? "bg-cc-yellow" : ""}`}
      style={headerStyle}
    >
      <div
        className={`mx-auto w-fit text-center text-lg ${
          settings.enable_high_contrast ? "text-cc-dark-gray" : "text-cc-gray"
        }`}
      >
        {before && parse(before)}
        {hasTimer && shouldShowTimer && secondsLeft > 0 && (
          <strong style={countdownStyle}>
            {parse(formatTime(secondsLeft))}
          </strong>
        )}
        {after && parse(after)}
      </div>
    </header>
  );
}
